import React from 'react';
import { Topbar } from './Topbar';
import { BottomNav } from './BottomNav';
import { SiteFooter } from './SiteFooter';
import { MobileStickyCTA } from './MobileStickyCTA';
import { BackToTop } from './BackToTop';
import { ScrollProgress } from './ScrollProgress';
import { PageTransition } from './PageTransition';
import { CoachChatWidget } from './CoachChatWidget';
import VisitorShortsPromo from './VisitorShortsPromo';
import { usePageViewTracker } from '../hooks/usePageViewTracker';
import { useScrollToTop } from '../hooks/useScrollToTop';

export const Layout = ({ children }) => {
  usePageViewTracker();
  useScrollToTop();
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden" data-testid="app-layout">
      <ScrollProgress />
      <Topbar />
      {/* QuickNavBars (Eleve + Moniteur) SUPPRIMÉES du Layout public.
          Le site public reste propre et immersif, sans pollution back-office.
          Les élèves/enseignants accèdent au back-office via le menu utilisateur
          en haut à droite. */}
      <main className="flex-1" data-testid="main-content">
        <div className="max-w-6xl xl:max-w-7xl 2xl:max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-6 py-6">
          <PageTransition>{children}</PageTransition>
        </div>
      </main>
      <SiteFooter />
      <BottomNav />
      <MobileStickyCTA />
      <BackToTop />
      <CoachChatWidget />
      <VisitorShortsPromo />
    </div>
  );
};
